import axiosNest from '../../api/axiosNest';

/**
 * Kalendarz zakazów ruchu ciężarówek — `/truck-bans` w API (19.10.2026;
 * odpowiedź Marathonu 16.10.2026 pyt. 11; przełącznik `truckBanCalendar`).
 * Tylko odczyt: dane zasiane z aktów prawnych, każdy wiersz z linkiem.
 */

/** Przełącznik funkcji — klucz z rejestru API (dane, nie przemianowujemy). */
export const FEATURE_TRUCK_BANS = 'truckBanCalendar';

export interface TruckBanCountry {
  country: string;
  name: string;
  generalBan: boolean;
  coveredFrom: string;
  coveredTo: string;
  summary: string;
  notCovered: string | null;
  legalBasis: string | null;
  sourceUrl: string | null;
}

export interface TruckBanRule {
  id: number;
  country: string;
  /** 1 = poniedziałek … 7 = niedziela. */
  weekday: number;
  startTime: string;
  endTime: string;
  validFrom: string | null;
  validTo: string | null;
  scope: string;
  vehicles: string;
  exceptions: string | null;
  legalBasis: string;
  sourceUrl: string;
}

export interface TruckBanDay {
  id: number;
  country: string;
  date: string;
  name: string;
  startTime: string;
  endTime: string;
  regions: string | null;
  scope: string;
  vehicles: string;
  exceptions: string | null;
  legalBasis: string;
  sourceUrl: string;
}

export interface TruckBanCalendarData {
  countries: TruckBanCountry[];
  rules: TruckBanRule[];
  days: TruckBanDay[];
}

/** Ostrzeżenie przy zleceniu (`order.truckBans` w rekomendacjach). */
export interface TruckBanWarning {
  country: string;
  point: 'loading' | 'unloading';
  start: string;
  end: string;
  text: string;
  regions: string | null;
  scope: string;
  legalBasis: string[];
  sourceUrls: string[];
}

export interface TruckBanCheck {
  warnings: TruckBanWarning[];
  notes: string[];
}

export const WEEKDAY_LABELS = [
  'poniedziałek',
  'wtorek',
  'środa',
  'czwartek',
  'piątek',
  'sobota',
  'niedziela',
];

export function weekdayLabel(n: number): string {
  return WEEKDAY_LABELS[n - 1] ?? `dzień ${n}`;
}

export async function fetchTruckBanCalendar(): Promise<TruckBanCalendarData> {
  const { data } = await axiosNest.get<TruckBanCalendarData>('/truck-bans');
  return {
    countries: Array.isArray(data?.countries) ? data.countries : [],
    rules: Array.isArray(data?.rules) ? data.rules : [],
    days: Array.isArray(data?.days) ? data.days : [],
  };
}
